// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HamburgerIcone_icone__eqdm3 {\n  display: flex;\n  width: var(--bar-xs);\n  justify-content: center;\n}\n@media (min-width: 600px) {\n  .HamburgerIcone_icone__eqdm3 {\n    width: var(--bar-sm);\n  }\n}\n", "",{"version":3,"sources":["webpack://src/Navigation/Hamburger/HamburgerIcone.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".icone {\n  display: flex;\n  width: var(--bar-xs);\n  justify-content: center;\n}\n@media (min-width: 600px) {\n  .icone {\n    width: var(--bar-sm);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icone": "HamburgerIcone_icone__eqdm3"
};
export default ___CSS_LOADER_EXPORT___;
